import { formatAmount } from "@/utils/formatAmount";

/** Net total of the line amounts the viewer is allowed to see.
 *
 * Rate visibility is enforced server-side (rate_visibility / rate-blind
 * gating nulls the amount of every line the user may not see), so this
 * component only ever sums what the API already disclosed. All lines hidden
 * (or none priced) → "—"; some hidden → the visible part marked with "*" so a
 * partially-permitted user never mistakes it for the full value.
 */
export function VisibleAmountSum({
  values,
}: {
  values: (string | null | undefined)[];
}) {
  const visible = values.filter((v): v is string => v != null);
  if (visible.length === 0) {
    return <span className="text-gray-300 dark:text-gray-600">—</span>;
  }
  const total = visible.reduce((sum, v) => sum + parseFloat(v), 0);
  const partial = visible.length < values.length;
  return (
    <span
      className="tabular-nums whitespace-nowrap"
      title={
        partial
          ? "Suma tylko z pozycji, do których masz uprawnienia finansowe"
          : undefined
      }
    >
      {formatAmount(total)} PLN
      {partial && <span className="text-gray-400 dark:text-gray-500">*</span>}
    </span>
  );
}
